import React from "react";
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { AppProvider, useApp } from "./context/AppContext";
import { useTranslation } from "react-i18next";
import "./i18n/index";
import "./index.css";
import Logo from "./components/Logo";
import IntroSplash from "./components/IntroSplash";
import { LOGO_APP_BOOT_LOADER } from "./config/logoSizes";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import VerifyEmail from "./pages/VerifyEmail";
import Chat from "./pages/Chat";
import Settings from "./pages/Settings";
import SharedChat from "./pages/SharedChat";
import ForgotPassword from "./pages/ForgotPassword";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import ResetPassword from "./pages/ResetPassword";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import WelcomeScreen from "./pages/WelcomeScreen";
import PrivacyPolicy from "./pages/PrivacyPolicy";
const Loader = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  return <div className="full-screen-center">
      <Logo variant="full" size={LOGO_APP_BOOT_LOADER} style={{ borderRadius: 16, animation: "logoFloat 3s ease-in-out infinite" }} />
      <div style={{ color: "var(--text-3)", fontSize: 13, fontFamily: "Outfit,sans-serif", letterSpacing: 1, direction: isAr ? "rtl" : "ltr" }}>
        {t("loadingApp")}
      </div>
    </div>;
};
const Protected = ({ children }) => {
  const { user, loading } = useApp();
  if (loading) return <Loader />;
  return user ? children : <Navigate to="/signin" replace />;
};
const Public = ({ children }) => {
  const { user, loading } = useApp();
  if (loading) return null;
  return !user ? children : <Navigate to="/chat" replace />;
};
function AppRoutes() {
  const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;
  return <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/chat" replace />} />
        <Route path="/signup" element={<Public><SignUp /></Public>} />
        <Route path="/signin" element={<Public><SignIn /></Public>} />
        <Route path="/verify-email" element={<Public><VerifyEmail /></Public>} />
        <Route path="/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/settings" element={<Protected><Settings /></Protected>} />
        <Route path="/shared/:shareToken" element={<SharedChat />} />
        <Route path="/forgot-password" element={<Public><ForgotPassword /></Public>} />
        <Route path="/reset-password/:token" element={<Public><ResetPassword /></Public>} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/payment-success" element={<Protected><PaymentSuccess /></Protected>} />
        <Route path="/payment-failed" element={<Protected><PaymentFailed /></Protected>} />
        <Route path="/welcome" element={<Protected><WelcomeScreen /></Protected>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </Router>;
}
function App() {
  return <div className="app-root-wrap">
      <IntroSplash />
      <AppProvider><AppRoutes /></AppProvider>
    </div>;
}
export {
  App as default
};
